import * as React from 'react';
import { Button, ButtonColorType } from '../Button';
import { Modal } from '../Modal';
import { getAssetPath } from '../../util/images';
import {
  ActionModalButtonsWrapper,
  ActionModalIcon,
  ActionModalImage,
  ActionModalText,
  ModalHeader
} from '../Modal/ActionModal';

const LeaveSceneModal = props => {
  const { onHide, onConfirm, show } = props;
  return (
    <Modal title="" show={show} onHide={onHide}>
      <ActionModalImage>
        <ActionModalIcon
          inAssetsPath={getAssetPath('icons/configuration-icon.svg')}
        />
      </ActionModalImage>
      <ModalHeader>Leave scene?</ModalHeader>
      <ActionModalText>All unsaved changes will be lost.</ActionModalText>
      <ActionModalButtonsWrapper>
        <Button
          colorType={ButtonColorType.WHITE}
          type="button"
          text="Cancel"
          onClick={() => onHide(false)}
        />
        <Button
          colorType={ButtonColorType.PRIMARY}
          type="button"
          text="Leave scene"
          onClick={() => onConfirm()}
        />
      </ActionModalButtonsWrapper>
    </Modal>
  );
};

export default LeaveSceneModal;
